import React, { useEffect } from 'react'
import { TextField, FormControl, Grid, MenuItem, Button } from '@mui/material';

import { LinearLoading, CustomAutocomplete } from 'common'

export const FilterForm = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions,
        Helpers
    } = useFetchInit

    const { FilterForm } = Forms
    const { formState, setFormState, onInputChange, onSelectSearchChange } = FilterForm

    const { fetchCategories, fetchAllCashRegisters, fetchTransactionsReport } = FetchData
    const { dataCategories, loadingFetchAllCategories } = fetchCategories
    const { dataCashRegisters, loadingFetchCashRegisters } = fetchAllCashRegisters

    const { handleClickPrintReport } = Actions

    useEffect(() => {

        setFormState(prevState => ({
            ...prevState,
            idcaja: ''
        }))
        fetchTransactionsReport.resetFetch()
        fetchAllCashRegisters.resetFetch()
        fetchAllCashRegisters.setParamsToSearch({
            idcategoria: formState.idcategoria,
            currency_type: formState.currency_type
        })
        fetchAllCashRegisters.executeFetch()

    }, [formState.idcategoria, formState.currency_type])

    return (
        <>
            <form>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="startDate">* Fecha de inicio</label>
                            <TextField
                                id='startDate'
                                name='startDate'
                                value={formState.startDate}
                                onChange={onInputChange}
                                size='small'
                                placeholder='Fecha de inicio'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="endDate">* Fecha fin</label>
                            <TextField
                                id='endDate'
                                name='endDate'
                                value={formState.endDate}
                                onChange={onInputChange}
                                size='small'
                                placeholder='Fecha de finalización'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>

                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idcategoria">* Categoría</label>
                            {(loadingFetchAllCategories)&&(<LinearLoading/>)}
                            <CustomAutocomplete 
                                customId="idcategoria"
                                customName="idcategoria"
                                customValue={formState.idcategoria}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcategoria', value: value.value }})}
                                customPlaceholder='Seleccionar opción'
                                customOptions={
                                    dataCategories.map(({ idcategoria, nombre }) => ({
                                        value: idcategoria,
                                        name: nombre
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={false}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="currency_type">* Moneda</label>
                            <TextField
                                id="currency_type"
                                name="currency_type"
                                value={formState.currency_type}
                                onChange={onInputChange}
                                select
                                size="small"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: false
                                }}
                            >
                                <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                <MenuItem value='DOLAR'>DOLAR</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-4"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idcaja">Caja</label>
                            {(loadingFetchCashRegisters)&&(<LinearLoading/>)}

                            <CustomAutocomplete
                                customId="idcaja"
                                customName="idcaja"
                                customValue={formState.idcaja}
                                customOnChange={(target, value) =>
                                    onSelectSearchChange({ target: { name: 'idcaja', value: value.value } })
                                }
                                customPlaceholder='Seleccionar caja'
                                customOptions={
                                    dataCashRegisters.map(({ idcaja, descripcion_corta, currency_type, saldo_caja }) => ({
                                        value: idcaja,
                                        name: `${descripcion_corta} - ${currency_type} - Q${parseFloat(saldo_caja).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={false}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_tipo">Tipo</label>

                            <TextField
                                id="movimiento_tipo"
                                name="movimiento_tipo"
                                value={formState.movimiento_tipo}
                                onChange={onInputChange}
                                select
                                size="small"
                                variant="outlined"
                                hiddenLabel
                                InputProps={{ readOnly: false }}
                            >
                                <MenuItem value='ALL'>MOVIMIENTOS (INGRESO + EGRESO)</MenuItem>
                                <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                <MenuItem value='EGRESO'>EGRESO</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>

                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <Button
                            style={{ background: "#4b4b4c" }}
                            variant="contained"
                            type='button'
                            onClick={handleClickPrintReport}
                            disabled={false}
                        >
                            <i className="fas fa-print"></i> &nbsp; Imprimir
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}